import axios from 'axios';

import { IHomeRecruiterAnalytics } from '../types/IHomeRecruiterAnalytics';

const url = '/wsreporting/api';

export const getRecruiterAnalyticsStatus = () => axios.get(`${url}/home-tab-analytics-status`);

export const saveRecruiterAnalytics = (data: IHomeRecruiterAnalytics) =>
  axios.post(`${url}/home-recruiter-analytics`, data);
